export default "__VITE_ASSET__DKlNqiuS__"